import React from 'react';
import { Icon } from '@osmosis/react-ui/components/Icon';
import { IconProps } from '@osmosis/react-ui/components/Icon';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';

type IconPropsOmitted = Omit<IconProps, 'icon'>;

type Props = IconPropsOmitted & {
  isRotated: boolean;
  icon?: IconDefinition;
};

/**
 * RotatingIcon component that rotates based on the isRotated prop.
 * @param {Props} props - The props for the component.
 * @param {boolean} props.isRotated - Determines if the icon should be rotated.
 * @param {IconDefinition} [props.icon=faChevronDown] - The icon to display.
 * @returns {JSX.Element} The rendered component.
 */
const RotatingIcon = (props: Props) => {
  const { isRotated, icon = faChevronDown, ...rest } = props;

  return (
    <div
      className={`transform transition-transform duration-300 ${
        isRotated ? 'rotate-180' : 'rotate-0'
      }`}
    >
      <Icon icon={icon} size="sm" {...rest} />
    </div>
  );
};

export default RotatingIcon;
